module.exports = __webpack_public_path__ + "img/up-live.9ae20e59.svg";